import { useApi } from "hooks/useApi";
import { AppDispatch } from "store";

const api = useApi();

export const getCategories = () => (dispatch: AppDispatch) => {
  api
    .get("/categories")
    .then((response) => {
      dispatch({ data: response.data, type: "SET_CATEGORIES" });
    })
    .catch((error) => {
      throw error;
    });
};

export const getFrames = () => (dispatch: AppDispatch) => {
  api
    .get("/frames")
    .then((response) => {
      dispatch({ data: response.data, type: "SET_FRAMES" });
    })
    .catch((error) => {
      throw error;
    });
};

export const getLenses = () => (dispatch: AppDispatch) => {
  return new Promise((resolve, reject) => {
    api
      .get("/lenses")
      .then((response) => {
        dispatch({ data: response.data, type: "SET_LENSES" });
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getLensMaterial = () => (dispatch: AppDispatch) => {
  api
    .get("/lens-materials")
    .then((response) => {
      dispatch({ data: response.data, type: "SET_LENS_MATERIAL" });
    })
    .catch((error) => {
      throw error;
    });
};

export const getLensColors = () => (dispatch: AppDispatch) => {
  api
    .get("/lens-colors")
    .then((response) => {
      dispatch({ data: response.data, type: "SET_LENS_COLORS" });
    })
    .catch((error) => {
      throw error;
    });
};

export const getOptions = () => (dispatch: AppDispatch) => {
  api
    .get("/options")
    .then((response) => {
      dispatch({ data: response.data, type: "SET_OPTIONS" });
    })
    .catch((error) => {
      throw error;
    });
}

export const getAdvancedOptions = () => (dispatch: AppDispatch) => {
  api
    .get("/advanced-options")
    .then((response) => {
      dispatch({ data: response.data, type: "SET_ADVANCED_OPTIONS" });
    })
    .catch((error) => {
      throw error;
    });
}